import { useState, useCallback } from "react"
import { isEqual } from "lodash"

/**
 * Hook that allows a component to work in both controlled and uncontrolled modes
 *
 * @param {*} prop - The controlled value (undefined means uncontrolled)
 * @param {*} defaultProp - The default value for uncontrolled mode
 * @param {function} onChange - Callback fired when the value changes
 * @returns {[*, function]} - [state, setState] tuple
 */
export function useControllableState(prop, defaultProp, onChange) {
  const [uncontrolledState, setUncontrolledState] = useState(defaultProp)
  const isControlled = prop !== undefined
  const state = isControlled ? prop : uncontrolledState

  const setState = useCallback((newState) => {
    if (!isControlled) {
      setUncontrolledState(newState)
    }

    // Only call onChange if the value has actually changed (using deep equality for arrays/objects)
    if (onChange && !isEqual(newState, state)) {
      onChange(newState)
    }
  }, [isControlled, onChange, state])

  return [state, setState]
}
